// Creative Canvas Labs — theme.js
// Cart drawer + quick add + qty handlers + PDP enhancements. Uses Shopify Ajax Cart API.

(function () {
  const drawer = document.querySelector('[data-cart-drawer]');

  // Every cart badge (mobile header, desktop header, mobile-nav) carries
  // [data-cart-count]; re-query on each write so re-rendered nodes are covered.
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('is-updated');
      void el.offsetHeight; // restart the pulse animation
      el.classList.add('is-updated');
    });
  }

  // ── Drawer open/close (animated) ──────────────────────────────────────────

  function animateOpen(el) {
    if (!el) return;
    el.hidden = false;
    el.classList.add('is-open');
    var panel = el.querySelector('.mobile-nav-panel, .cart-drawer, .filter-drawer-panel');
    if (panel) {
      // Force inline transform after a paint tick — covers cases where visibility changes block the CSS transition
      setTimeout(function () {
        panel.style.transform = 'translateX(0)';
      }, 16);
    }
    trapFocus(el);
  }

  function animateClose(el) {
    if (!el) return;
    el.classList.remove('is-open');
    var panel = el.querySelector('.mobile-nav-panel, .cart-drawer, .filter-drawer-panel');
    if (panel) {
      panel.style.transform = '';  // revert to CSS default (off-screen)
    }
    releaseFocus(el);
    // Fallback for hidden state — keep DOM tractable
    setTimeout(function () { el.hidden = true; }, 350);
  }

  function openDrawer() { hydrateCartRecs(drawer); animateOpen(drawer); }
  function closeDrawer() { animateClose(drawer); }
  function openPanel(sel) { animateOpen(document.querySelector(sel)); }
  function closePanel(sel) { animateClose(document.querySelector(sel)); }

  // ── Focus trap ──────────────────────────────────────────────────────────────

  function trapFocus(container) {
    const focusable = Array.from(
      container.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;
    focusable[0].focus();
    container._trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    container.addEventListener('keydown', container._trapHandler);
  }

  function releaseFocus(container) {
    if (container && container._trapHandler) {
      container.removeEventListener('keydown', container._trapHandler);
      delete container._trapHandler;
    }
  }

  // Escape closes any open drawer
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    var fd = document.querySelector('[data-filter-drawer]');
    if (fd && !fd.hidden) animateClose(fd);
    var mn = document.querySelector('[data-mobile-nav]');
    if (mn && !mn.hidden) animateClose(mn);
  });

  // ── Click delegation ────────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
    if (e.target.closest('[data-filter-open]')) { e.preventDefault(); openPanel('[data-filter-drawer]'); }
    if (e.target.closest('[data-filter-close]')) { e.preventDefault(); closePanel('[data-filter-drawer]'); }
    if (e.target.closest('[data-mobile-open]')) { e.preventDefault(); openPanel('[data-mobile-nav]'); }
    if (e.target.closest('[data-mobile-close]')) { e.preventDefault(); closePanel('[data-mobile-nav]'); }

    // PDP thumbnail gallery
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var idx = thumb.getAttribute('data-thumb');
      var gallery = thumb.closest('[data-pdp-gallery]');
      if (gallery) {
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        gallery.querySelectorAll('[data-stage]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-stage') === idx); });
      }
    }

    // X-sell size picker — reveal the chip row, closing any other open picker in the grid
    var pick = e.target.closest('[data-xsell-pick]');
    if (pick) {
      e.preventDefault();
      var xcard = pick.closest('[data-xsell-card]');
      var xlist = xcard && xcard.querySelector('[data-xsell-variants]');
      if (xlist) {
        var willOpen = xlist.hidden;
        var xgrid = pick.closest('.cart-xsell-grid');
        if (xgrid) {
          xgrid.querySelectorAll('[data-xsell-variants]').forEach(function (l) { l.hidden = true; });
          xgrid.querySelectorAll('[data-xsell-pick]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        }
        xlist.hidden = !willOpen;
        pick.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }
    }

    // Cart item remove (Ajax)
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeCartItem(rm.getAttribute('data-cart-remove'), 0); }
  });

  // ── Button feedback helper ─────────────────────────────────────────────────

  function btnFeedback(btn, state, text, duration) {
    if (!btn) return;
    btn.classList.remove('is-adding', 'is-added', 'is-error');
    btn.classList.add(state);
    var orig = btn._origText || btn.textContent;
    if (!btn._origText) btn._origText = orig;
    btn.textContent = text;
    if (duration) {
      setTimeout(function () {
        btn.classList.remove('is-adding', 'is-added', 'is-error');
        btn.textContent = btn._origText;
        btn.disabled = false;
        delete btn._origText;
      }, duration);
    }
  }

  // ── Quick add ───────────────────────────────────────────────────────────────

  document.addEventListener('click', async function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    if (parseInt(quick.getAttribute('data-variant-count') || '1', 10) > 1) {
      window.location.href = quick.getAttribute('data-product-url');
      return;
    }
    var id = quick.getAttribute('data-quick-add');
    quick.disabled = true;
    btnFeedback(quick, 'is-adding', 'Adding…');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCartDrawer();
      btnFeedback(quick, 'is-added', 'Added ✓', 1400);
      openDrawer();
    } catch (err) {
      btnFeedback(quick, 'is-error', 'Error', 1400);
      console.error(err);
    }
  });

  // ── Qty + / - (in-place, no reload) ────────────────────────────────────────

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-qty-up], [data-qty-down]');
    if (!btn) return;
    var key = btn.dataset.key;
    var input = drawer && drawer.querySelector('input[data-key="' + key + '"]');
    if (!input) return;
    var dir = btn.matches('[data-qty-up]') ? 1 : -1;
    var next = Math.max(0, parseInt(input.value, 10) + dir);
    btn.disabled = true;
    await changeCartItem(key, next);
    btn.disabled = false;
  });

  // Manual qty input change
  document.addEventListener('change', async function (e) {
    if (!e.target.matches('input[name="updates[]"][data-key]')) return;
    var key = e.target.getAttribute('data-key');
    var next = Math.max(0, parseInt(e.target.value, 10) || 0);
    await changeCartItem(key, next);
  });

  // ── "Add the full look" ─────────────────────────────────────────────────────

  document.addEventListener('click', async function (e) {
    var fullLook = e.target.closest('[data-add-full-look]');
    if (!fullLook) return;
    e.preventDefault();
    var ids = (fullLook.getAttribute('data-add-full-look') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    fullLook.disabled = true;
    btnFeedback(fullLook, 'is-adding', 'Adding…');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }),
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCartDrawer();
      btnFeedback(fullLook, 'is-added', 'Added ✓', 2000);
      openDrawer();
    } catch (err) {
      btnFeedback(fullLook, 'is-error', 'Error — try again', 2000);
      console.error(err);
    }
  });

  // ── PDP option completeness check ──────────────────────────────────────────
  // Builds the selected-options map exactly as the option-button click handler
  // does, and returns the first option group with no selection (or null if all
  // groups have a selection). On failure also surfaces the inline error UI.
  function firstUnselectedOption(form) {
    if (!form) return null;
    var firstMissing = null;
    form.querySelectorAll('.pdp-option').forEach(function (opt) {
      if (firstMissing) return;
      var active = opt.querySelector('.pdp-option-btn.is-active');
      if (!active) firstMissing = opt;
    });
    return firstMissing;
  }

  function flagMissingOption(form, missing) {
    var err = form.querySelector('[data-pdp-error]');
    if (err) {
      err.removeAttribute('hidden');
      err.textContent = 'Select a size to continue';
    }
    if (missing) {
      var btn = missing.querySelector('.pdp-option-btn:not(.is-disabled)') || missing.querySelector('.pdp-option-btn');
      if (btn) btn.focus();
    }
  }

  // ── Mobile sticky CTA → delegates click to main PDP form ───────────────────

  document.addEventListener('click', function (e) {
    var mobileAdd = e.target.closest('[data-pdp-mobile-add]');
    if (!mobileAdd) return;
    var form = document.querySelector('.pdp-form');
    if (!form) return;
    var submit = form.querySelector('.pdp-add');
    // Sold out (or an add already in flight): requestSubmit() ignores a disabled
    // submitter, so guard here instead of POSTing a 422 to /cart/add.js.
    if (mobileAdd.disabled || (submit && submit.disabled)) return;
    var missing = firstUnselectedOption(form);
    if (missing) { flagMissingOption(form, missing); return; }
    if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
  });

  // Auto-hide mobile CTA when the desktop add-to-cart button is in viewport
  (function () {
    var pdpSubmit = document.querySelector('.pdp-form button[type="submit"]');
    var mobileCta = document.querySelector('[data-pdp-mobile-cta]');
    if (!pdpSubmit || !mobileCta) return;
    // aria-hidden is owned here (not hardcoded in Liquid) so it is only true
    // while the bar is actually suppressed behind the in-view desktop button.
    function setHidden(hidden) {
      mobileCta.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      mobileCta.style.pointerEvents = hidden ? 'none' : '';
    }
    setHidden(false);
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      setHidden(entries[0].isIntersecting);
    }, { threshold: 0.5 }).observe(pdpSubmit);
  }());

  // ── PDP form — AJAX submit → open cart drawer ───────────────────────────────

  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('.pdp-form');
    if (!form) return;
    e.preventDefault();
    // Completeness check — every option group must have a selection
    var missing = firstUnselectedOption(form);
    if (missing) { flagMissingOption(form, missing); return; }
    var submit = form.querySelector('button[type="submit"]');
    var stickyBtn = document.querySelector('[data-pdp-mobile-add]'); // mobile sticky mirror
    submit.disabled = true;
    btnFeedback(submit, 'is-adding', 'Adding…');
    if (stickyBtn) { stickyBtn.disabled = true; btnFeedback(stickyBtn, 'is-adding', 'Adding…'); }
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCartDrawer();
      btnFeedback(submit, 'is-added', 'Added ✓', 1500);
      if (stickyBtn) btnFeedback(stickyBtn, 'is-added', 'Added ✓', 1500);
      openDrawer();
    } catch (err) {
      console.error(err);
      btnFeedback(submit, 'is-error', 'Error — try again', 1500);
      if (stickyBtn) btnFeedback(stickyBtn, 'is-error', 'Error — try again', 1500);
    }
  });

  // ── Cart helpers ────────────────────────────────────────────────────────────

  async function changeCartItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    await refreshCartDrawer();
  }

  var _cartRefreshing = false;
  async function refreshCartDrawer() {
    if (!drawer || _cartRefreshing) return;
    _cartRefreshing = true;
    drawer.classList.add('is-loading');
    try {
      var res = await fetch('/?sections=cart-drawer');
      if (res.ok) {
        var data = await res.json();
        var html = data['cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (fresh) {
            var wasOpen = drawer.classList.contains('is-open');
            drawer.innerHTML = fresh.innerHTML;
            drawer.hidden = false;
            if (wasOpen) drawer.classList.add('is-open');
            hydrateCartRecs(drawer); // fresh placeholder → refetch recs with the new seed + exclusions
          }
        }
      }
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      setCartCount(cart.item_count);
      await refreshCartPage(); // no-op everywhere except /cart
    } catch (err) {
      console.error('Cart refresh error:', err);
    } finally {
      _cartRefreshing = false;
      drawer.classList.remove('is-loading');
    }
  }

  // ── Cart recommendations ("you may also like") ─────────────────────────────
  // Placeholders ([data-cart-recs]) carry a pre-built /recommendations/products
  // URL rendered by sections/cart-recommendations.liquid, which excludes in-cart
  // products and falls back to collections server-side. Idempotent per element.

  function hydrateCartRecs(scope) {
    var els = (scope || document).querySelectorAll('[data-cart-recs]:not([data-recs-loaded])');
    els.forEach(function (el) {
      var url = el.getAttribute('data-recs-url');
      if (!url) { el.hidden = true; return; }
      el.setAttribute('data-recs-loaded', '1');
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('recs ' + r.status)); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-cart-recs-content]');
          var cards = content ? content.querySelectorAll('[data-xsell-card]') : [];
          if (!cards.length) throw new Error('empty');
          var limit = parseInt(el.getAttribute('data-limit') || '3', 10);
          for (var i = limit; i < cards.length; i++) cards[i].remove();
          el.innerHTML = content.innerHTML;
        })
        .catch(function () {
          var wrap = el.closest('[data-cart-recs-wrap]');
          (wrap || el).hidden = true;
        });
    });
  }

  async function refreshCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    // Don't clobber the page while the user is mid-edit in a qty/note field
    if (page.contains(document.activeElement) && document.activeElement.matches('input, textarea')) return;
    try {
      var res = await fetch('/cart?section_id=main-cart');
      if (!res.ok) return;
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var fresh = doc.querySelector('[data-cart-page]');
      if (fresh) {
        page.replaceWith(fresh);
        hydrateCartRecs(fresh);
      }
    } catch (err) {
      console.error('Cart page refresh error:', err);
    }
  }

  // Cart page recs strip hydrates on load; the drawer's hydrates lazily on open
  var cartPageEl = document.querySelector('[data-cart-page]');
  if (cartPageEl) hydrateCartRecs(cartPageEl);

  // ── PDP image lightbox (click main image → fullscreen, click to zoom + pan) ──
  (function () {
    var lb = document.querySelector('[data-pdp-lightbox]');
    if (!lb) return;
    // Move to <body> so fixed positioning covers the sticky header (escapes any stacking context)
    if (lb.parentElement !== document.body) document.body.appendChild(lb);
    var stage = lb.querySelector('[data-lightbox-stage]');
    var img = lb.querySelector('[data-lightbox-img]');
    var counter = lb.querySelector('[data-lightbox-counter]');
    var ZOOM = 2.5;
    var slides = [], current = 0, zoomed = false;

    function collect() {
      slides = Array.prototype.map.call(
        document.querySelectorAll('.pdp-media[data-zoom-src]'),
        function (f) { return { src: f.getAttribute('data-zoom-src'), alt: f.getAttribute('data-zoom-alt') || '' }; }
      );
    }
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      resetZoom();
      img.src = slides[current].src;
      img.alt = slides[current].alt;
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }
    function open(i) {
      collect();
      if (!slides.length) return;
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      show(i);
    }
    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      resetZoom();
    }
    function resetZoom() {
      zoomed = false;
      lb.classList.remove('is-zoomed');
      img.style.transform = 'translate(0,0) scale(1)';
    }
    function panTo(clientX, clientY) {
      var r = stage.getBoundingClientRect();
      var fx = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      var fy = Math.min(1, Math.max(0, (clientY - r.top) / r.height));
      var panX = (0.5 - fx) * (ZOOM - 1) * img.clientWidth;
      var panY = (0.5 - fy) * (ZOOM - 1) * img.clientHeight;
      img.style.transform = 'translate(' + panX.toFixed(1) + 'px,' + panY.toFixed(1) + 'px) scale(' + ZOOM + ')';
    }

    // Distinguish a deliberate tap from a scroll swipe (so scrolling over the
    // image on touch devices never opens the lightbox / locks the page)
    var tStartX = 0, tStartY = 0, tMoved = false;
    document.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      tMoved = false; tStartX = e.touches[0].clientX; tStartY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches[0]) return;
      if (Math.abs(e.touches[0].clientX - tStartX) > 10 || Math.abs(e.touches[0].clientY - tStartY) > 10) tMoved = true;
    }, { passive: true });

    // Open from the active main image
    document.addEventListener('click', function (e) {
      var media = e.target.closest('.pdp-media.is-active');
      if (!media) return;
      if (!media.hasAttribute('data-zoom-src')) return; // video stage — nothing to zoom
      if (tMoved) return; // gesture was a scroll, not a tap — don't open
      e.preventDefault();
      var gallery = media.closest('[data-pdp-gallery]');
      var all = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.pdp-media[data-zoom-src]')) : [];
      var idx = all.indexOf(media);
      open(idx < 0 ? 0 : idx);
    });

    // Toggle zoom on the lightbox image
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      zoomed = !zoomed;
      lb.classList.toggle('is-zoomed', zoomed);
      if (zoomed) panTo(e.clientX, e.clientY); else resetZoom();
    });
    // Pan while zoomed (mouse + touch drag)
    stage.addEventListener('pointermove', function (e) {
      if (zoomed) panTo(e.clientX, e.clientY);
    });
    // Click backdrop (not the image) closes
    stage.addEventListener('click', function (e) {
      if (e.target === stage) close();
    });

    lb.querySelector('[data-lightbox-close]').addEventListener('click', close);
    lb.querySelector('[data-lightbox-prev]').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    lb.querySelector('[data-lightbox-next]').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  })();

})();

// ── Dropdown nav ─────────────────────────────────────────────────────────────
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nav-dropdown]');
    if (btn) {
      var item = btn.closest('.hdr-nav-item');
      var wasOpen = item && item.classList.contains('is-open');
      document.querySelectorAll('.hdr-nav-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-nav-dropdown]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (item && !wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.hdr-nav-item')) {
      document.querySelectorAll('.hdr-nav-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-nav-dropdown]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hdr-nav-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-nav-dropdown]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });
}());

// ── Predictive search ─────────────────────────────────────────────────────────
(function () {
  var toggle = document.querySelector('[data-search-toggle]');
  var panel = document.querySelector('[data-search-panel]');

  function clearResults(results) {
    results.innerHTML = '';
    results.classList.remove('has-results');
  }

  function bindSearch(widget) {
    var input = widget.querySelector('[data-search-input]');
    var results = widget.querySelector('[data-search-results]');
    if (!input || !results) return;

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search-widget]') && !e.target.closest('[data-search-toggle]')) {
        clearResults(results);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && results.classList.contains('has-results')) {
        clearResults(results);
        input.blur();
      }
    });

    var searchTimer;
    input.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        clearResults(results);
        return;
      }
      searchTimer = setTimeout(async function () {
        try {
          var res = await fetch(
            '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=5'
          );
          if (!res.ok) return;
          var data = await res.json();
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<div class="hdr-search-empty">No results for “' + q + '”</div>';
          } else {
            results.innerHTML = products.map(function (p) {
              var imgSrc = p.featured_image && p.featured_image.url
                ? p.featured_image.url + '&width=112'
                : '';
              var price = p.price ? '$' + parseFloat(p.price).toFixed(2) : '';
              return '<a href="' + p.url + '" class="hdr-search-result">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="" width="56" height="56" loading="lazy">' : '<div style="width:56px;height:56px;background:var(--paper);"></div>') +
                '<div><div class="hdr-search-result-title">' + p.title + '</div>' +
                '<div class="hdr-search-result-price">' + price + '</div></div>' +
                '</a>';
            }).join('');
          }
          results.classList.add('has-results');
        } catch (err) {
          console.error('Search error:', err);
        }
      }, 260);
    });
  }

  document.querySelectorAll('[data-search-widget]').forEach(bindSearch);

  if (toggle && panel) {
    var panelInput = panel.querySelector('[data-search-input]');
    var panelResults = panel.querySelector('[data-search-results]');

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) { setTimeout(function () { if (panelInput) panelInput.focus(); }, 50); }
      else if (panelResults) { clearResults(panelResults); }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search-panel]') && !e.target.closest('[data-search-toggle]')) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (panelResults) clearResults(panelResults);
        toggle.focus();
      }
    });
  }
}());

// ── Load more (collection page) ───────────────────────────────────────────────
(function () {
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    // The trigger is an <a class="btn" data-load-more> (sections/main-collection.liquid),
    // so "disabled" is expressed with a class + aria-disabled, not the disabled property.
    if (btn.classList.contains('is-loading')) return;
    var url = btn.getAttribute('data-load-more') || btn.getAttribute('href');
    if (!url) return;
    var originalHTML = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Loading…';
    try {
      var res = await fetch(url);
      if (!res.ok) throw new Error('Failed to load');
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.querySelector('.coll-grid-editorial');
      if (grid) {
        doc.querySelectorAll('.coll-grid-editorial > *').forEach(function (card) { grid.appendChild(card); });
      }
      // Keep the list / build-log view in step with the grid
      var listBody = document.querySelector('[data-view-list] tbody');
      if (listBody) {
        doc.querySelectorAll('[data-view-list] tbody > tr').forEach(function (row) { listBody.appendChild(row); });
      }
      // Wire up swatches (and any other card behaviours) on the newly added cards;
      // quick-add is delegated at document level so it needs no re-init.
      document.dispatchEvent(new CustomEvent('products:loaded'));
      // Swap in the fetched page's own trigger (it points at page N+1); when the
      // fetched page has no next page, remove the trigger entirely.
      var nextBtn = doc.querySelector('[data-load-more]');
      var wrap = btn.closest('.coll-load-more-wrap');
      if (nextBtn) {
        btn.replaceWith(nextBtn);
      } else if (wrap) {
        wrap.remove();
      } else {
        btn.remove();
      }
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
      btn.innerHTML = originalHTML;
      console.error('Load more error:', err);
    }
  });
}());

// ── Collection sort flags keep the active filter params ───────────────────────
// The Liquid renders bare ?sort_by=… hrefs; merge each one into the current
// query string so sorting never discards filter.* params (and vice versa —
// the filter form carries sort_by server-side in main-collection.liquid).
(function () {
  var flags = document.querySelectorAll('.coll-sort-flags a[href*="sort_by="]');
  if (!flags.length) return;
  flags.forEach(function (a) {
    try {
      var target = new URL(a.getAttribute('href'), location.href);
      var sortBy = target.searchParams.get('sort_by');
      if (!sortBy) return;
      var merged = new URL(location.href);
      merged.searchParams.set('sort_by', sortBy);
      merged.searchParams.delete('page'); // a new sort order restarts pagination
      merged.hash = '';
      a.setAttribute('href', merged.pathname + merged.search);
    } catch (_) {}
  });
}());

// ── Header height CSS variable ────────────────────────────────────────────────
(function () {
  var hdr = document.querySelector('[data-header]');
  if (!hdr) return;
  function set() { document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px'); }
  set();
  window.addEventListener('resize', set, { passive: true });
}());

// ── Promo tiles (parallax shirt-image marketing, shuffled per view) ────────────
(function () {
  function cfg() {
    var el = document.getElementById('CCLPromo');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  window.cclPromoTileHTML = function (span) {
    var c = cfg(); if (!c) return '';
    var inner = '<div class="promo-tile-inner">' +
      (c.kicker ? '<div class="promo-tile-kicker">' + esc(c.kicker) + '</div>' : '') +
      '<div class="promo-tile-headline">' + esc(c.headline) + '</div>' +
      (c.subtext ? '<div class="promo-tile-sub">' + esc(c.subtext) + '</div>' : '') +
      '<span class="promo-tile-cta">' + esc(c.cta_label) + '</span></div>';
    return '<a class="promo-tile" data-promo-tile href="' + esc(c.cta_url || '/collections/all') +
      '" style="grid-column: span ' + span + ';" aria-label="' + esc(c.headline) + '">' +
      '<span class="promo-tile-bg" data-promo-bg aria-hidden="true"></span>' + inner + '</a>';
  };
  window.cclPromoInit = function () {
    var c = cfg();
    var imgs = (c && c.images ? c.images : []).filter(Boolean);
    if (!imgs.length) return;
    // Track images already used on this page so multiple tiles don't repeat the
    // same shot (refills once every image has been used). Still random per load.
    window._cclPromoUsed = window._cclPromoUsed || [];
    document.querySelectorAll('[data-promo-tile]:not([data-promo-ready])').forEach(function (el) {
      el.setAttribute('data-promo-ready', '1');
      var avail = imgs.filter(function (u) { return window._cclPromoUsed.indexOf(u) === -1; });
      if (!avail.length) { window._cclPromoUsed = []; avail = imgs.slice(); }
      var u = avail[Math.floor(Math.random() * avail.length)];
      window._cclPromoUsed.push(u);
      var bg = el.querySelector('[data-promo-bg]');
      if (bg) bg.style.backgroundImage = "url('" + u + "')";
      el.classList.add('has-img');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.cclPromoInit);
  } else {
    window.cclPromoInit();
  }
}());

// ── Adjacent objects (related products) ─────────────────────────────────────
// [data-adjacent] carries the product's collections, most specific first.
// Each is fetched as /collections/<h>?sort_by=best-selling&sections=pdp-adjacent
// so cards arrive in best-selling order; the current product is skipped, ids
// are de-duplicated across collections, and we stop at data-limit. Falls back
// to Shopify's recommendations endpoint when no collection handles exist.
(function () {
  var sec = document.querySelector('[data-adjacent]');
  if (!sec) {
    // Older cached markup: fill the legacy recommendations placeholder instead.
    var old = document.getElementById('product-recommendations');
    if (old && old.getAttribute('data-url')) {
      fetch(old.getAttribute('data-url')).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'); var sct = d.querySelector('[data-recommendations-section]');
        if (sct && sct.children.length) { old.replaceWith(sct); if (window.cclPromoInit) window.cclPromoInit(); } else old.remove();
      }).catch(function () { old.remove(); });
    }
    return;
  }
  var grid = sec.querySelector('[data-adjacent-grid]');
  var pid = sec.getAttribute('data-product-id');
  var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
  var handles = (sec.getAttribute('data-collections') || '').split(',').filter(Boolean);

  function finish(cards) {
    if (!grid || !cards.length) return;
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    if (window.cclPromoTileHTML && cards.length >= 3 && cards.length % 3 !== 0) {
      var wrap = document.createElement('div');
      wrap.innerHTML = window.cclPromoTileHTML(3 - (cards.length % 3));
      while (wrap.firstChild) frag.appendChild(wrap.firstChild);
    }
    var g = grid;
    if (g.id === 'product-recommendations') { g = document.createElement('div'); g.className = 'bento-grid'; grid.replaceWith(g); }
    g.innerHTML = '';
    g.appendChild(frag);
    if (window.cclPromoInit) window.cclPromoInit();
    if (window.cclInitSwatches) window.cclInitSwatches(g);
  }

  function legacy() {
    var url = grid && grid.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('[data-recommendations-section]');
        if (section && section.children.length) { grid.replaceWith(section); if (window.cclPromoInit) window.cclPromoInit(); }
        else if (!grid.children.length) grid.remove();
      })
      .catch(function () { if (grid && !grid.children.length) grid.remove(); });
  }

  if (!handles.length) { legacy(); return; }
  var picked = [], seen = {};
  seen[pid] = true;
  function step(i) {
    if (i >= handles.length || picked.length >= limit) return Promise.resolve();
    // Hourly cache-buster: Shopify caches section renders per exact URL, and a
    // URL first requested while the section was missing stays cached as null.
    return fetch('/collections/' + handles[i] + '?sort_by=best-selling&sections=pdp-adjacent&_=' + Math.floor(Date.now() / 3600000))
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json['pdp-adjacent'] || '', 'text/html');
        doc.querySelectorAll('.pcard[data-product-id]').forEach(function (card) {
          var id = card.getAttribute('data-product-id');
          if (seen[id] || picked.length >= limit) return;
          seen[id] = true;
          picked.push(card);
        });
      })
      .catch(function () {})
      .then(function () { return step(i + 1); });
  }
  step(0).then(function () { if (picked.length) finish(picked); else legacy(); });
}());

// ── Product card color swatches ───────────────────────────────────────────────
(function () {
  var COLOR_MAP = {
    black: '#1a1a1a', white: '#f5f5f5', red: '#d63031', blue: '#2980b9',
    navy: '#1a2f5a', grey: '#888', gray: '#888', green: '#27ae60',
    yellow: '#f1c40f', pink: '#fd79a8', purple: '#8e44ad', orange: '#e67e22',
    brown: '#795548', tan: '#d4a057', beige: '#e8d5b7', cream: '#fffdd0',
    maroon: '#800000', heather: '#9a9a9a', charcoal: '#555', gold: '#f9a825',
    silver: '#bdbdbd', teal: '#009688', coral: '#ff6b6b', olive: '#6b7c2d',
    burgundy: '#800020', slate: '#607d8b', sand: '#d4b483', stone: '#b5a898',
    khaki: '#c3b091', rose: '#e8b4b8', mint: '#98d8c8', lavender: '#d8b4d8',
    magenta: '#c2185b', cyan: '#00acc1', indigo: '#3949ab', lime: '#7cb342',
    'solid black': '#1a1a1a', 'solid white': '#f5f5f5', 'dark gray': '#444',
    'light gray': '#ccc', 'heather gray': '#9a9a9a', 'royal blue': '#2962ff',
    'forest green': '#2e7d32', 'kelly green': '#4caf50',
  };

  function colorToCss(name) {
    var lower = name.toLowerCase();
    if (COLOR_MAP[lower]) return COLOR_MAP[lower];
    for (var key in COLOR_MAP) {
      if (lower.indexOf(key) !== -1) return COLOR_MAP[key];
    }
    return '#c8c8c8';
  }

  window.cclInitSwatches = initSwatches;
  function initSwatches(root) {
    (root || document).querySelectorAll('.pcard-swatches').forEach(function (container) {
      // Idempotent: never bind the same card twice (safe to re-run after AJAX)
      if (container.dataset.swatchInit === '1') return;
      container.dataset.swatchInit = '1';
      var card = container.closest('.pcard');
      var frontImg = card && card.querySelector('.pcard-img-front');
      var backImg = card && card.querySelector('.pcard-img-back');
      if (!frontImg) return;

      var origFrontSrc = frontImg.getAttribute('src') || '';
      var origFrontSrcset = frontImg.getAttribute('srcset') || '';
      var origBackSrc = backImg ? (backImg.getAttribute('src') || '') : '';
      var origBackSrcset = backImg ? (backImg.getAttribute('srcset') || '') : '';

      function applyImg(src) {
        frontImg.src = src;
        frontImg.removeAttribute('srcset');
        if (backImg) { backImg.src = src; backImg.removeAttribute('srcset'); }
      }

      function restoreImgs() {
        var active = container.querySelector('.pcard-swatch.is-active');
        var src = active ? active.dataset.img : '';
        if (src) {
          applyImg(src);
        } else {
          frontImg.src = origFrontSrc;
          if (origFrontSrcset) frontImg.setAttribute('srcset', origFrontSrcset);
          if (backImg) {
            backImg.src = origBackSrc;
            if (origBackSrcset) backImg.setAttribute('srcset', origBackSrcset);
          }
        }
      }

      container.querySelectorAll('.pcard-swatch').forEach(function (swatch) {
        swatch.style.setProperty('--swatch-bg', colorToCss(swatch.dataset.color || ''));

        swatch.addEventListener('mouseenter', function (e) {
          e.preventDefault();
          var src = swatch.dataset.img;
          if (src) applyImg(src);
        });

        swatch.addEventListener('mouseleave', function (e) {
          e.preventDefault();
          restoreImgs();
        });

        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          container.querySelectorAll('.pcard-swatch').forEach(function (s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');
          var src = swatch.dataset.img;
          if (src) applyImg(src);
        });

        swatch.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); swatch.click(); }
        });
      });
    });
  }

  initSwatches();
  document.addEventListener('cart:refresh', function () { initSwatches(); });
  // Re-init when new product cards are injected (load-more, AJAX filtering, etc.)
  document.addEventListener('products:loaded', function () { initSwatches(); });
}());

// ── Recently viewed ───────────────────────────────────────────────────────────
(function () {
  var KEY = 'rv_products';
  var MAX = 6;

  var jsonEl = document.getElementById('ProductJson');
  if (jsonEl) {
    try {
      var p = JSON.parse(jsonEl.textContent);
      var rawSrc = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.src) || '';
      var src = rawSrc ? rawSrc.replace(/^\/\//, 'https://').replace(/^http:\/\//, 'https://') : '';
      var entry = { handle: p.handle, title: p.title, price: p.price, image: src, url: p.url || '/products/' + p.handle };
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
      list = list.filter(function (i) { return i.handle !== entry.handle; });
      list.unshift(entry);
      if (list.length > MAX) list = list.slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (_) {}
  }

  var rvEl = document.getElementById('recently-viewed');
  if (!rvEl) return;
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
  var currentHandle = rvEl.getAttribute('data-current');
  if (currentHandle) list = list.filter(function (i) { return i.handle !== currentHandle; });
  if (!list.length) { rvEl.remove(); return; }

  function rvImgSrc(raw) {
    if (!raw) return '';
    var url = raw.replace(/^\/\//, 'https://').replace(/^http:\/\//, 'https://');
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=600';
  }

  var cols = Math.min(list.length, 4);
  var cards = list.map(function (p) {
    var price = p.price ? '$' + (p.price / 100).toFixed(2) : '';
    var imgSrc = rvImgSrc(p.image);
    return '<a href="' + p.url + '" class="pcard" style="background:var(--bg);">' +
      '<div class="pcard-media">' +
      (imgSrc ? '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" class="pcard-img-front">' : '') +
      '</div>' +
      '<div class="pcard-meta"><div class="pcard-title">' + p.title + '</div>' +
      '<div class="mono pcard-price">' + price + '</div></div></a>';
  }).join('');

  var rvMod = list.length % cols;
  var rvLeftover = rvMod === 0 ? 0 : cols - rvMod;
  var rvPromo = '';
  if (rvLeftover > 0 && document.getElementById('CCLPromo') && window.cclPromoTileHTML) {
    rvPromo = window.cclPromoTileHTML(rvLeftover);
  }

  rvEl.outerHTML = '<section class="rv-section">' +
    '<h2 class="display" style="font-size:clamp(28px,3vw,40px); margin:0; line-height:.95;">Recently viewed</h2>' +
    '<div class="rv-grid" style="grid-template-columns:repeat(' + cols + ',1fr);">' + cards + rvPromo + '</div></section>';
  if (window.cclPromoInit) window.cclPromoInit();
}());


// ── Stat counter animation ────────────────────────────────────────────────────
(function () {
  var els = document.querySelectorAll('[data-count]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var raw = el.getAttribute('data-count');
      if (/^(19|20)\d{2}$/.test(raw)) { el.textContent = raw; return; }
      var m = raw.match(/^([^0-9]*)([0-9]+\.?[0-9]*)([^0-9]*)$/);
      if (!m) return;
      var prefix = m[1], target = parseFloat(m[2]), suffix = m[3];
      var isInt = Number.isInteger(target);
      var start = performance.now();
      var dur = 1100;
      (function step(now) {
        var t = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var val = eased * target;
        el.textContent = prefix + (isInt ? Math.round(val) : val.toFixed(1)) + suffix;
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      }(start));
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { observer.observe(el); });
}());

// ── Custom cursor removed — native cursor restored ────────────────────────────

// ── Cart discount code + drawer order note ────────────────────────────────────
// Delegated, so both the cart page and the (re-rendered) drawer are covered.
(function () {
  function applyDiscount(scope) {
    var input = scope.querySelector('[data-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    // Shopify applies the code to the session, then honours ?redirect=.
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-discount-apply]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-cart-discount]');
    if (scope) applyDiscount(scope);
  });

  // Enter inside the code field must not submit the surrounding cart form
  // (that would fire the cart update/checkout instead of applying the code).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-discount-input]');
    if (!input) return;
    e.preventDefault();
    var scope = input.closest('[data-cart-discount]');
    if (scope) applyDiscount(scope);
  });

  // Persist the drawer note as soon as focus leaves it, so a drawer re-render
  // (triggered by any quantity change) can't discard what was typed.
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value }),
    }).catch(function () {});
  }, true);
}());

// ── Back-in-stock notification form ───────────────────────────────────────────
// Now a native {% form 'customer' %} POST in main-product.liquid — the address
// is stored in Admin tagged back-in-stock + restock-<handle>. The former JS
// handler here intercepted the submit and faked a "queued [OK]" state without
// sending anything, discarding every lead; do not reintroduce it.

// ── PDP media video — respect reduced motion (no autoplay, expose controls) ──
(function () {
  if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  document.querySelectorAll('.pdp-media video[autoplay]').forEach(function (v) {
    v.removeAttribute('autoplay');
    v.setAttribute('controls', '');
    try { v.pause(); } catch (e) {}
  });
}());

// ── Hero clip reel ────────────────────────────────────────────────────────────
// The desktop video panel plays the hero's "Video clip" blocks back to back,
// cross-fading between two stacked <video>s so clips change without a black
// frame. hero.liquid renders one product tag per clip; only the playing clip's
// tag is shown, and a click anywhere on the panel opens that product.
// Phones/tablets (≤900px) and reduced motion get the first clip's still + tag:
// no source is ever assigned there, so no video bytes load.
(function () {
  // Originals above this play Shopify's biggest MP4 copy instead. The export
  // spec asks for ≤4MB; this only catches a raw export uploaded by mistake.
  var MAX_ORIGINAL = 8 * 1048576;

  function matches(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }

  function initReel(panel) {
    if (!panel || panel._reel) return;
    var v = panel.querySelector('.t-render-video');
    var clips = [].slice.call(panel.querySelectorAll('[data-clip]'));
    if (!v || !clips.length) return;

    var n = clips.length;
    var active = 0;
    var state = clips.map(function (c) {
      return {
        hls: c.getAttribute('data-hls') || '',
        orig: c.getAttribute('data-orig') || '',
        mp4: c.getAttribute('data-mp4') || '',
        poster: c.getAttribute('data-poster') || ''
      };
    });
    var reel = panel._reel = { jump: function () {}, destroy: function () {} };

    function show(i) {
      clips.forEach(function (c, j) { c.hidden = j !== i; });
      active = i;
    }

    // The tag is the real, keyboard-reachable link; a click anywhere else on
    // the panel follows it too. Exception: a desktop panel whose autoplay was
    // blocked (Low Power Mode etc.) — there the first click starts playback.
    // .t-render-video is pointer-events:none, so clicks land on the panel.
    var blocked = false;
    panel.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a, button')) return;
      if (blocked) { blocked = false; playCur(); return; }
      var t = clips[active].querySelector('.t-render-tag');
      if (!t) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) window.open(t.href, '_blank');
      else window.location.href = t.href;
    });

    var desktop = matches('(min-width: 901px)');
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    // Phones play too (the panel sits right under the headline there); Data
    // Saver and reduced motion keep the still.
    if (saveData || matches('(prefers-reduced-motion: reduce)')) {
      // The markup still is sized for phones; on a desktop panel swap in the
      // sharper copy — unless it's a merchant-set panel still
      if (desktop && v.hasAttribute('data-auto-poster') && state[0].poster) v.setAttribute('poster', state[0].poster);
      reel.jump = function (i) {
        if (i < 0 || i >= n) return;
        show(i);
        if (state[i].poster) v.setAttribute('poster', state[i].poster);
      };
      return;
    }

    var nativeHls = !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
    var inView = true;
    // Pause/play control (WCAG 2.2.2 — the reel moves and changes its link on
    // its own, so anyone must be able to stop it). A user pause outlasts
    // scrolling away and tab switches; it also doubles as the play button
    // when the browser blocked autoplay.
    var userPaused = false;
    var toggle = panel.querySelector('[data-reel-toggle]');
    function renderToggle() {
      if (!toggle) return;
      var off = userPaused || blocked;
      toggle.textContent = off ? '▶ play' : '|| pause';
      toggle.setAttribute('aria-label', off ? 'Play video' : 'Pause video');
    }
    if (toggle) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        if (userPaused || blocked) { userPaused = false; blocked = false; playCur(); }
        else { userPaused = true; pauseAll(); }
        renderToggle();
      });
    }
    // While the pointer is over the panel or a tag has keyboard focus, the
    // playing clip loops instead of advancing — the tag mustn't change under a
    // click that's on its way, and it gives keyboard users a pause
    var hovering = false, focused = false;
    panel.addEventListener('mouseenter', function () { hovering = true; });
    panel.addEventListener('mouseleave', function () { hovering = false; });
    panel.addEventListener('focusin', function () { focused = true; });
    panel.addEventListener('focusout', function () { focused = false; });
    var waiting = false; // the playing clip ended; swap as soon as the buffer can play
    var fading = false;  // mid cross-fade: the outgoing element isn't free yet
    var gen = 0;

    // `cur` is on screen; `nxt` buffers the following clip at opacity 0
    var cur = v;
    var nxt = null;
    if (n > 1) {
      nxt = v.cloneNode(false);
      nxt.removeAttribute('poster');
      nxt.classList.add('is-standby');
      v.parentNode.insertBefore(nxt, v.nextSibling);
    }
    v.classList.add('is-front');
    [cur, nxt].forEach(function (el) {
      if (!el) return;
      // iOS honours these as properties, not just markup attributes
      el.muted = true; el.defaultMuted = true; el.playsInline = true;
      el.loop = n === 1;
      el.addEventListener('error', function () { onError(el); });
      el.addEventListener('canplay', function () {
        el._readyFor = el._clip;
        if (el === nxt && waiting && el._clip === nextIndex(active)) swap();
      });
      el.addEventListener('playing', function () {
        if (el === cur) { blocked = false; renderToggle(); queueNext(); }
      });
      el.addEventListener('ended', function () {
        if (el !== cur) return;
        if (hovering || focused) {
          try { el.currentTime = 0; } catch (e) {}
          attempt(el);
          return;
        }
        waiting = true;
        advance();
      });
    });

    // Is the original upload small enough to play? One HEAD request per clip.
    function prepare(i) {
      var s = state[i];
      if (!s.orig) return Promise.resolve();
      if (!s.check) {
        s.check = !window.fetch ? Promise.resolve(s.origOk = true)
          : fetch(s.orig, { method: 'HEAD' }).then(function (r) {
              var len = parseInt(r.headers.get('content-length') || '0', 10);
              s.origOk = r.ok && !(len > MAX_ORIGINAL);
            }, function () { s.origOk = true; });
      }
      return s.check;
    }
    // Best first: the original upload (full resolution from the first frame),
    // then Shopify's HLS stream where it plays natively (Safari and current
    // Chrome — but it opens each clip on the 480p copy before stepping up,
    // which is most of a 6–10s clip), then Shopify's biggest MP4 copy.
    // Phones flip the first two: the adaptive stream is far lighter on a
    // cellular connection and the panel is only ~390px wide.
    function candidates(i) {
      var s = state[i], out = [];
      if (!desktop && nativeHls && s.hls) out.push(s.hls);
      if (s.orig && s.origOk) out.push(s.orig);
      if (desktop && nativeHls && s.hls) out.push(s.hls);
      if (s.mp4) out.push(s.mp4);
      return out;
    }
    // keepPoster: the opener keeps the markup still — swapping in the sharper
    // copy a moment before the first frame just adds a later paint (LCP)
    function setClip(el, i, keepPoster) {
      el._clip = i; el._try = 0; el._readyFor = null;
      return prepare(i).then(function () {
        if (el._clip !== i) return; // re-targeted while the size check ran
        var list = candidates(i);
        if (!list.length) { fail(el, i); return; }
        if (!keepPoster && state[i].poster) el.setAttribute('poster', state[i].poster);
        // preload must be raised off the markup's "none" or nothing buffers
        el.preload = 'auto';
        el.src = list[0];
        try { el.load(); } catch (e) {}
      });
    }
    function onError(el) {
      var i = el._clip;
      if (i == null) return;
      // Some Chromium builds claim HLS support they can't deliver — walk down
      // the candidates before giving up on the clip
      var list = candidates(i);
      if (++el._try < list.length) {
        el.src = list[el._try];
        try { el.load(); } catch (e) {}
        return;
      }
      fail(el, i);
    }
    function fail(el, i) {
      state[i].bad = true;
      if (el === cur || waiting) { waiting = true; advance(); }
      else queueNext();
    }

    function nextIndex(from) {
      for (var k = 1; k <= n; k++) {
        var j = (from + k) % n;
        if (!state[j].bad) return j;
      }
      return -1;
    }
    function attempt(el) {
      var p = el.play();
      if (p && p.catch) p.catch(function (err) {
        if (el === cur && err && err.name === 'NotAllowedError') { blocked = true; renderToggle(); }
      });
    }
    function playCur() {
      var el = cur;
      if (userPaused || !inView || document.hidden || !el.getAttribute('src')) return;
      if (el.readyState >= 2) attempt(el);
      else el.addEventListener('canplay', function () {
        if (el === cur && inView && !document.hidden) attempt(el);
      }, { once: true });
    }
    function pauseAll() {
      [cur, nxt].forEach(function (el) { if (el) { try { el.pause(); } catch (e) {} } });
    }

    // Buffer the clip after the active one — only while the panel is on screen
    function queueNext() {
      if (!nxt || !inView || fading) return;
      var j = nextIndex(active);
      if (j < 0 || j === active || nxt._clip === j) return;
      setClip(nxt, j);
    }
    function advance() {
      var j = nextIndex(active);
      if (j < 0) { waiting = false; return; } // nothing playable: keep the still
      if (!nxt || j === active) {             // one playable clip left: loop it
        waiting = false;
        cur.loop = true;
        try { cur.currentTime = 0; } catch (e) {}
        attempt(cur);
        return;
      }
      if (fading) return; // the fade's timeout re-queues; the canplay handler swaps
      if (nxt._clip !== j) setClip(nxt, j);
      else if (nxt._readyFor === j) swap();
    }
    function swap() {
      var inc = nxt, out = cur, g = ++gen;
      waiting = false;
      fading = true;
      cur = inc; nxt = out;
      out.classList.remove('is-front');
      inc.classList.add('is-front');
      inc.classList.remove('is-standby');
      show(inc._clip);
      playCur();
      // Let the cross-fade finish before recycling the outgoing element
      setTimeout(function () {
        if (g !== gen) return;
        fading = false;
        out.classList.add('is-standby');
        try { out.pause(); } catch (e) {}
        queueNext();
      }, 600);
    }

    var io = null;
    if ('IntersectionObserver' in window) {
      // Back in view → resume; the 'playing' handler then buffers the next
      // clip, so the opener never shares bandwidth with it on page load
      io = new IntersectionObserver(function (entries) {
        inView = entries[entries.length - 1].isIntersecting;
        if (inView) playCur(); else pauseAll();
      }, { threshold: 0.1 });
      io.observe(panel);
    }
    function onVisibility() { if (document.hidden) pauseAll(); else playCur(); }
    document.addEventListener('visibilitychange', onVisibility);

    // Theme editor: selecting a clip block cuts straight to that clip
    reel.jump = function (i) {
      if (i < 0 || i >= n) return;
      gen++;
      fading = false; waiting = false;
      state[i].bad = false;
      if (nxt) { nxt.classList.add('is-standby'); nxt.classList.remove('is-front'); nxt._clip = null; }
      cur.classList.add('is-front'); cur.classList.remove('is-standby');
      show(i);
      setClip(cur, i).then(playCur);
      queueNext();
    };
    reel.destroy = function () {
      if (io) io.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      pauseAll();
    };

    show(0);
    // On phones the clip waits for window load so it never competes with the
    // first paint (the still is already showing)
    var start = function () { setClip(cur, 0, true).then(playCur); };
    if (desktop || document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }

  function initAll(root) {
    [].forEach.call((root || document).querySelectorAll('[data-hero-reel]'), initReel);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  // Theme editor: re-init after a section re-render, stop on removal, and jump
  // to a clip when its block is selected in the sidebar.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-hero-reel]'), function (p) {
      if (p._reel) p._reel.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var clip = e.target && e.target.closest ? e.target.closest('[data-clip]') : null;
    var panel = clip && clip.closest('[data-hero-reel]');
    if (!panel || !panel._reel) return;
    panel._reel.jump([].indexOf.call(panel.querySelectorAll('[data-clip]'), clip));
  });
}());

// ── Scan-bench parallax ───────────────────────────────────────────────────────
(function () {
  function init() {
    var section = document.querySelector('[data-scanbench]');
    if (!section) return;
    var stage = section.querySelector('.t-scanbench-stage');
    if (!stage) return;
    var grid = section.querySelector('.t-scanbench-grid');
    var tee = section.querySelector('.t-scanbench-tee');
    var reveal = section.querySelector('.t-scanbench-tee .reveal');
    var beam = section.querySelector('.t-scanbench-beam');
    var specimen = section.querySelector('.t-scanbench-specimen');
    var callouts = section.querySelectorAll('.t-scanbench-callout');
    var fore = section.querySelector('.t-scanbench-fore');
    var track = section.querySelector('.t-scanbench-track i');
    var readout = section.querySelector('[data-scanbench-readout]');

    function apply(p) {
      var vh = window.innerHeight || 800;
      stage.style.setProperty('--p', p.toFixed(4));
      // Background grid: slow upward drift
      if (grid) grid.style.transform = 'translateY(' + (p * -0.14 * vh).toFixed(1) + 'px)';
      // Ghost wordmark: large drift, centred at p=0.5
      if (specimen) specimen.style.transform = 'translate(-50%, calc(-50% + ' + ((0.5 - p) * 0.60 * vh).toFixed(1) + 'px))';
      // Specimen tee: gentle drift, centred at p=0.5
      if (tee) tee.style.transform = 'translate(-50%, calc(-50% + ' + ((0.5 - p) * 0.26 * vh).toFixed(1) + 'px))';
      // Analysed reveal — clip-path set directly (calc(var()) in clip-path is unreliable)
      if (reveal) reveal.style.clipPath = 'inset(0 0 ' + ((1 - p) * 100).toFixed(1) + '% 0)';
      // Scan beam rides the reveal edge
      if (beam) { beam.style.top = (p * 100).toFixed(1) + '%'; beam.style.opacity = (0.35 + p * 0.65).toFixed(2); }
      // Callouts drift at varied depths, centred at p=0.5
      callouts.forEach(function (co) {
        var d = parseFloat(co.style.getPropertyValue('--d')) || 0;
        co.style.transform = 'translateY(' + ((0.5 - p) * d * 4).toFixed(1) + 'px)';
      });
      // Foreground copy: subtle counter-drift
      if (fore) fore.style.transform = 'translateY(' + ((0.5 - p) * -0.10 * vh).toFixed(1) + 'px)';
      // Readout bar + percentage
      if (track) track.style.width = (p * 100).toFixed(1) + '%';
      if (readout) readout.textContent = String(Math.round(p * 100)).padStart(3, '0') + '%';
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      apply(0.55);
      return;
    }

    var ticking = false, visible = true;
    function loop() {
      ticking = false;
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - vh)));
      apply(p);
    }
    window.addEventListener('scroll', function () {
      if (visible && !ticking) { requestAnimationFrame(loop); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', loop);
    // Only run the scroll loop while the section is on-screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) loop();
      }, { rootMargin: '200px 0px' });
      io.observe(section);
    }
    loop();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());

// ── PDP Terminal option-button click → sync hidden radio ──────────────────────
(function () {
  // Resolve the currently-selected variant from active option buttons and sync
  // hidden id input, add button, stock pill, gallery image and price. Shared by
  // the click handler and the on-load init (so a pre-highlighted size registers).
  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Price markup mirroring sections/main-product.liquid: current price, then a
  // struck compare-at price and a [-NN%] badge only when the variant is on sale.
  // (Shopify's product JSON carries compare_at_price in cents, or null.)
  function priceHTML(variant, withBadge) {
    var html = '<span class="price-current">' + money(variant.price) + '</span>';
    var cmp = variant.compare_at_price;
    if (typeof cmp === 'number' && cmp > variant.price) {
      html += ' <s class="price-compare">' + money(cmp) + '</s>';
      if (withBadge) {
        var pct = Math.floor(((cmp - variant.price) / cmp) * 100);
        html += ' <span class="badge-sale">[-' + pct + '%]</span>';
      }
    }
    return html;
  }

  // Desktop .pdp-add and the mobile sticky [data-pdp-mobile-add] share one label
  // + disabled state. If add feedback ("Adding…"/"Added ✓") is mid-flight,
  // btnFeedback restores btn._origText when it ends — retarget that instead of
  // clobbering the feedback text.
  function syncAddBtn(btn, available) {
    if (!btn) return;
    var label = available ? '$ add --to=cart' : '$ sold_out';
    btn.disabled = !available;
    if (btn._origText) btn._origText = label; else btn.textContent = label;
  }

  function resolveVariant(form, opts) {
    if (!form) return;
    opts = opts || {};
    var productJson = document.getElementById('ProductJson');
    if (!productJson) return;
    try {
      var p = JSON.parse(productJson.textContent);
      var selected = {};
      form.querySelectorAll('.pdp-option').forEach(function (opt) {
        var active = opt.querySelector('.pdp-option-btn.is-active');
        if (active) selected[active.dataset.optionName] = active.dataset.optionValue;
      });
      var fits = function (v) {
        return p.options.every(function (oname, i) {
          return !selected[oname] || selected[oname] === v['option' + (i + 1)];
        });
      };
      var match = p.variants.find(fits);
      // The combination doesn't exist (e.g. XS picked, then a colour that has
      // no XS): keep the option just clicked and move the others to the
      // closest variant that has it — available first — so the cart id,
      // price and gallery never stay on the previous colour.
      if (!match && opts.changed) {
        var ci = p.options.indexOf(opts.changed.name);
        var withIt = p.variants.filter(function (v) { return v['option' + (ci + 1)] === opts.changed.value; });
        match = withIt.find(function (v) { return v.available; }) || withIt[0];
        if (match) {
          form.querySelectorAll('.pdp-option-btn').forEach(function (b) {
            var oi = p.options.indexOf(b.dataset.optionName);
            if (oi < 0) return;
            var on = match['option' + (oi + 1)] === b.dataset.optionValue;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
      }
      if (match) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;
        syncAddBtn(form.querySelector('.pdp-add'), match.available);
        syncAddBtn(document.querySelector('[data-pdp-mobile-add]'), match.available);

        // Keep the stock pill (in_stock:NN / low / sold_out) in sync with the variant
        var stockEl = document.querySelector('[data-pdp-stock]');
        if (stockEl) {
          stockEl.classList.remove('out', 'low');
          if (!match.available) {
            stockEl.textContent = 'sold_out';
            stockEl.classList.add('out');
          } else {
            var tracked = match.inventory_management === 'shopify';
            var qty = match.inventory_quantity;
            if (tracked && typeof qty === 'number' && qty > 0) {
              stockEl.textContent = 'in_stock:' + (qty < 10 ? '0' + qty : qty);
              if (qty <= 5) stockEl.classList.add('low');
            } else {
              stockEl.textContent = 'in_stock';
            }
          }
        }

        // Switch the main gallery image to the selected variant's image.
        // Skipped on initial load so media position 1 (e.g. a product video)
        // stays in the stage; only user swatch clicks retarget the gallery.
        // Some sizes of a colour carry no image of their own — fall back to
        // any variant of the same colour that does.
        var pos = match.featured_media && match.featured_media.position;
        var colorIx = p.options.findIndex(function (o) { return /^colou?r$/i.test(o); });
        if (!pos && colorIx >= 0) {
          var sib = p.variants.find(function (v) {
            return v['option' + (colorIx + 1)] === match['option' + (colorIx + 1)] && v.featured_media;
          });
          pos = sib && sib.featured_media.position;
        }
        if (pos && !opts.skipGallery) {
          var idx = String(pos - 1);
          var gallery = document.querySelector('[data-pdp-gallery]');
          if (gallery) {
            gallery.querySelectorAll('[data-stage]').forEach(function (s) {
              s.classList.toggle('is-active', s.getAttribute('data-stage') === idx);
            });
            gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
              t.classList.toggle('is-active', t.getAttribute('data-thumb') === idx);
            });
          }
        }

        // Keep price (desktop + mobile sticky) in sync with the variant,
        // including the struck compare-at price and [-NN%] sale badge.
        if (typeof match.price === 'number') {
          var priceEl = document.querySelector('.pdp-price');
          if (priceEl) priceEl.innerHTML = priceHTML(match, true);
          var mPrice = document.querySelector('[data-pdp-mobile-price]');
          if (mPrice) mPrice.innerHTML = priceHTML(match, false);
        }
      }
    } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-option-btn');
    if (!btn || btn.classList.contains('is-disabled')) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;
    // Mark active among siblings (keep aria-pressed in sync)
    var group = btn.parentElement;
    if (group) group.querySelectorAll('.pdp-option-btn').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    resolveVariant(form, { changed: { name: btn.dataset.optionName, value: btn.dataset.optionValue } });
  });

  // Clicking a thumbnail that is a colour's image selects that colour, so the
  // photo on screen and the variant going into the cart always agree. Other
  // shots (back view, lifestyle, video) only change the stage.
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    var form = document.querySelector('.pdp-form');
    var productJson = document.getElementById('ProductJson');
    if (!thumb || !form || !productJson) return;
    try {
      var p = JSON.parse(productJson.textContent);
      var colorIx = p.options.findIndex(function (o) { return /^colou?r$/i.test(o); });
      if (colorIx < 0) return;
      var pos = +thumb.getAttribute('data-thumb') + 1;
      var owner = p.variants.find(function (v) { return v.featured_media && v.featured_media.position === pos; });
      if (!owner) return;
      var color = owner['option' + (colorIx + 1)];
      var btn = [].find.call(form.querySelectorAll('.pdp-option-btn'), function (b) {
        return b.dataset.optionName === p.options[colorIx] && b.dataset.optionValue === color;
      });
      if (btn && !btn.classList.contains('is-active') && !btn.classList.contains('is-disabled')) btn.click();
    } catch (err) {}
  });

  // On load, resolve the pre-highlighted size into the hidden id input
  function init() {
    var form = document.querySelector('.pdp-form');
    if (!form) return;
    // Sync aria-pressed with the server-rendered is-active state
    form.querySelectorAll('.pdp-option-btn').forEach(function (b) {
      b.setAttribute('aria-pressed', b.classList.contains('is-active') ? 'true' : 'false');
    });
    resolveVariant(form, { skipGallery: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());

// ── PDP description read-more (full copy stays in DOM for SEO) ─────────────────
(function () {
  function init() {
    document.querySelectorAll('[data-pdp-desc]').forEach(function (desc) {
      var toggle = desc.parentElement.querySelector('[data-pdp-desc-toggle]');
      if (!toggle) return;
      // Bind the click handler once
      if (toggle.dataset.descBound !== '1') {
        toggle.dataset.descBound = '1';
        toggle.addEventListener('click', function () {
          var expanded = desc.classList.toggle('is-expanded');
          desc.classList.toggle('is-clamped', !expanded);
          toggle.innerHTML = expanded
            ? 'read less <span class="pre" aria-hidden="true">−</span>'
            : 'read more <span class="pre" aria-hidden="true">+</span>';
        });
      }
      // Don't recompute once the user has expanded it
      if (desc.classList.contains('is-expanded')) return;
      // Clamp, then only keep the clamp + toggle if the content actually overflows
      desc.classList.add('is-clamped');
      if (desc.scrollHeight > desc.clientHeight + 4) {
        toggle.hidden = false;
      } else {
        desc.classList.remove('is-clamped');
        toggle.hidden = true;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  // Re-evaluate after web fonts settle (line heights can shift)
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(init); }
}());

// ── PDP qty buttons ───────────────────────────────────────────────────────────
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-qty button[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var delta = parseInt(btn.dataset.qty, 10) || 0;
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    input.value = v;
  });
}());

// ── Override: remove hidden attribute coupling on drawer/mobile-nav wraps ─────
(function () {
  function unhide() {
    var d = document.querySelector('[data-cart-drawer]');
    if (d && d.hasAttribute('hidden')) d.removeAttribute('hidden');
    var m = document.querySelector('[data-mobile-nav]');
    if (m && m.hasAttribute('hidden')) m.removeAttribute('hidden');
  }
  unhide();
  document.addEventListener('DOMContentLoaded', unhide);
  // Re-unhide after any class-change observation
  var mo = new MutationObserver(function (recs) {
    recs.forEach(function (r) {
      if (r.attributeName === 'hidden') {
        r.target.removeAttribute('hidden');
      }
    });
  });
  var d = document.querySelector('[data-cart-drawer]');
  if (d) mo.observe(d, { attributes: true, attributeFilter: ['hidden'] });
  var m = document.querySelector('[data-mobile-nav]');
  if (m) mo.observe(m, { attributes: true, attributeFilter: ['hidden'] });
}());

/* ── FAQ accordion ─────────────────────────────────────────── */
(function () {
  function initFaq() {
    document.querySelectorAll('.pdp-faq-q').forEach(function (btn) {
      if (btn.dataset.faqInit) return;
      btn.dataset.faqInit = '1';
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          if (expanded) { panel.setAttribute('hidden', ''); }
          else { panel.removeAttribute('hidden'); }
        }
      });
    });
  }
  initFaq();
  document.addEventListener('DOMContentLoaded', initFaq);
}());

